import { isFullPlanUser } from "../Helpers/Functions/Selectors/auth"
import { UserPlan } from "../Models/API/UserModel"
import { useAppState } from "./useReduxState"

export const useUserPlan = (): UserPlan => {
    const isFullUser = useAppState(isFullPlanUser)

    return isFullUser ? UserPlan.FULL : UserPlan.FREEMIUM
}
